module.exports = __webpack_public_path__ + "assets/img/face_check_example3.1bdf53d5.jpg";